import { Flex } from "@chakra-ui/react";

// Empty by inheritance, like FooterAdmin — kept for the bottom spacing it adds
// to the auth layout.
export default function Footer() {
  return (
    <Flex
      zIndex="3"
      flexDirection={{
        base: "column",
        lg: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="space-between"
      px={{ base: "30px", md: "0px" }}
      pb="30px"
    ></Flex>
  );
}
